export default __webpack_public_path__ + "static/cultura-aziendale-positiva-98c0705d17f89d5654d8ae57158ac9e2.jpg";